/**
 * MathLive 简体中文本地化字符串。
 *
 * MathLive 官方未内置中文，本文件通过 `MathfieldElement.strings` 注入
 * `zh-Hans` 翻译，覆盖虚拟键盘 tooltip、上下文菜单、颜色名等 UI 文案。
 *
 * 字符串 key 与英文版（@arnog/mathlive l10n-strings.ts）严格对齐，
 * 不在此表中的 key MathLive 会自动 fallback 到英文。
 */

export const MATHLIVE_ZH_HANS_STRINGS: Record<string, string> = {
  'keyboard.tooltip.symbols': '符号',
  'keyboard.tooltip.greek': '希腊字母',
  'keyboard.tooltip.numeric': '数字',
  'keyboard.tooltip.alphabetic': '字母',

  'tooltip.copy to clipboard': '复制到剪贴板',
  'tooltip.cut to clipboard': '剪切到剪贴板',
  'tooltip.paste from clipboard': '从剪贴板粘贴',
  'tooltip.redo': '重做',
  'tooltip.undo': '撤销',
  'tooltip.toggle virtual keyboard': '切换虚拟键盘',
  'tooltip.menu': '菜单',
  'tooltip.blackboard': '空心字体',
  'tooltip.bold': '粗体',
  'tooltip.italic': '斜体',
  'tooltip.fraktur': '哥特体',
  'tooltip.script': '手写体',
  'tooltip.caligraphic': '书法体',
  'tooltip.typewriter': '等宽体',
  'tooltip.roman-upright': '罗马正体',
  'tooltip.row-by-col': '%@ × %@',

  // 矩阵相关
  'menu.borders': '边框',
  'menu.insert matrix': '插入矩阵',
  'menu.array.add row above': '在上方插入行',
  'menu.array.add row below': '在下方插入行',
  'menu.array.add column after': '在右侧插入列',
  'menu.array.add column before': '在左侧插入列',
  'menu.array.delete row': '删除行',
  'menu.array.delete rows': '删除选中行',
  'menu.array.delete column': '删除列',
  'menu.array.delete columns': '删除选中列',

  // 模式
  'menu.mode': '模式',
  'menu.mode-math': '数学',
  'menu.mode-text': '文本',
  'menu.mode-latex': 'LaTeX',

  // 插入子菜单
  'menu.insert': '插入',
  'menu.insert.abs': '绝对值',
  'menu.insert.nth-root': 'n 次方根',
  'menu.insert.log-base': '以 a 为底的对数',

  'menu.insert.heading-calculus': '微积分',
  'menu.insert.derivative': '导数',
  'menu.insert.nth-derivative': 'n 阶导数',
  'menu.insert.integral': '积分',
  'menu.insert.sum': '求和',
  'menu.insert.product': '求积',

  'menu.insert.heading-complex-numbers': '复数',
  'menu.insert.modulus': '模',
  'menu.insert.argument': '辐角',
  'menu.insert.real-part': '实部',
  'menu.insert.imaginary-part': '虚部',
  'menu.insert.conjugate': '共轭',

  // 字体与样式
  'menu.font-style': '字体样式',
  'menu.accent': '注音符号',
  'menu.decoration': '装饰',
  'menu.color': '颜色',
  'menu.background-color': '背景色',
  'menu.evaluate': '求值',
  'menu.simplify': '化简',
  'menu.solve': '求解',
  'menu.solve-for': '对 %@ 求解',

  // 剪贴板
  'menu.cut': '剪切',
  'menu.copy': '复制',
  'menu.copy-as-latex': '复制为 LaTeX',
  'menu.copy-as-typst': '复制为 Typst',
  'menu.copy-as-ascii-math': '复制为 ASCII Math',
  'menu.copy-as-mathml': '复制为 MathML',
  'menu.paste': '粘贴',
  'menu.select-all': '全选',

  // 颜色
  'color.red': '红色',
  'color.orange': '橙色',
  'color.yellow': '黄色',
  'color.lime': '青柠',
  'color.green': '绿色',
  'color.teal': '青色',
  'color.cyan': '蓝绿',
  'color.blue': '蓝色',
  'color.indigo': '靛蓝',
  'color.purple': '紫色',
  'color.magenta': '品红',
  'color.black': '黑色',
  'color.dark-grey': '深灰',
  'color.grey': '灰色',
  'color.light-grey': '浅灰',
  'color.white': '白色',
}
